import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

interface IDateTextProps {
  value: string; // ISO compliant date string
  format: string;
  render: (stringDate: string) => JSX.Element;
}
export default function DateText({ value, format, render }: IDateTextProps) {
  const [date, setDate] = useState(() => dayjs(new Date(value)).format(format));
  useEffect(() => {
    setDate(dayjs(new Date(value)).format(format));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return render(date);
}
